// extracted by mini-css-extract-plugin
export default {"fields":"Clb9R_","time":"WDboHT","mobile":"EdwZ6X"};